import React from 'react';
import moment from 'moment';

import { Day, DefaultDateType, ShiftClickHanlederType } from '../types';
import { timeShiftLegends } from '../utils';

import '../shift-and-schedule.css';

import { CellWithTime } from './CellWithTime';
import { CellWithoutTIme } from './CellWithoutTIme';

type Props = {
  startOfMonth: DefaultDateType;
  day: Day;
  onClick: ({ rowIndex, columnData }: ShiftClickHanlederType) => void;
};

export function ShiftDayCell({ startOfMonth, day, onClick }: Props) {
  const hanleClick = () => {
    onClick({ columnData: day });
  };

  return (
    <>
      {!day?.code ? (
        <CellWithTime day={day} style={timeShiftLegends[3]} />
      ) : !moment(startOfMonth).isSame(day?.date, 'month') ? (
        <CellWithTime day={day} style={timeShiftLegends[3]} />
      ) : day?.isHoliday ? (
        <CellWithoutTIme
          day={day}
          style={timeShiftLegends[6]}
          label={timeShiftLegends[6]?.label}
        />
      ) : day?.isLeave ? (
        <CellWithoutTIme
          day={day}
          style={timeShiftLegends[5]}
          label={timeShiftLegends[5]?.label}
        />
      ) : day?.isWeekOff ? (
        <CellWithoutTIme
          onClick={hanleClick}
          day={day}
          style={timeShiftLegends[1]}
          label={timeShiftLegends[1]?.label}
        />
      ) : day?.isOvernight ? (
        <CellWithTime
          day={day}
          style={timeShiftLegends[4]}
          onClick={hanleClick}
        />
      ) : day?.isFlexi ? (
        <CellWithTime
          day={day}
          style={timeShiftLegends[2]}
          onClick={hanleClick}
        />
      ) : (
        <CellWithTime
          day={day}
          style={timeShiftLegends[0]}
          onClick={hanleClick}
        />
      )}
    </>
  );
}
